// extracted by css-extract-rspack-plugin
export default {"select":"_HUtZLjUh2UBJOLH","value":"tYE5hljDemESmfLN"};